import DashboardLayout from "@/packages/dashboard/views/DashboardLayout.vue";
// import {Auth} from "@/packages/auth";
import EntityOnboarding from "@/packages/WaasModules/Onboarding/component/EntityOnboarding.vue";
import BeneficiaryOnboarding from "@/packages/WaasModules/Onboarding/component/BeneficiaryOnboarding.vue";

const OnboardingRoutes =[
    {
        path: '/dashboard/waas/onboarding',
        component: DashboardLayout,
        children: [
            {
                path: 'entity',
                component: EntityOnboarding,
                name: "EntityOnboarding",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'beneficiary',
                component: BeneficiaryOnboarding,
                name: "BeneficiaryOnboarding",
                // meta: { middleware: [Auth]},
            },
        ]
    }
];
export default OnboardingRoutes;
